import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=0572c23a"
import script from "./Sort.vue?vue&type=script&lang=ts"
export * from "./Sort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports